const VU_DB_MIN = -60;
const VU_DB_MAX = 6;
const VU_DB_RANGE = VU_DB_MAX - VU_DB_MIN;

/**
 * Matches sheetmuse-web-app meter math:
 * linear RMS gain -> dB
 */
export function gainToDb(gain: number): number {
  if (gain === 0 || !Number.isFinite(gain)) {
    return Number.NEGATIVE_INFINITY;
  }
  return 20 * Math.log10(gain);
}

/**
 * Matches sheetmuse-web-app meter math:
 * dB in [-60, +6] mapped to 0..100%
 */
export function vuLevelPercentFromRmsDb(rmsDb: number): number {
  if (rmsDb === Number.NEGATIVE_INFINITY) {
    return 0;
  }
  return Math.max(0, Math.min(100, ((rmsDb - VU_DB_MIN) / VU_DB_RANGE) * 100));
}

/**
 * Convenience for band-sync-lab UI which uses 0..1 level.
 */
export function meterLevel01FromRmsLinear(rmsLinear: number): number {
  const percent = vuLevelPercentFromRmsDb(gainToDb(rmsLinear));
  const normalized = percent / 100;
  // Make low-mid program material read much more visibly in the lab UI.
  // Exponent < 1 increases sensitivity at lower levels.
  return Math.pow(normalized, 0.55);
}

export function meterPercentFromLevel01(level01: number): number {
  if (!Number.isFinite(level01)) return 0;
  return Math.max(0, Math.min(100, level01 * 100));
}
